import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import Theme from '../../theme';
import { Tile } from '../../ui';
import ArrowIcon from "../../assets/icons/arrow.svg";
import { defaultScale } from '../../utils/scaling';

export const ProfileNavigationTile = ({ title, onPress, icon }) => {
  return (
    <Tile onPress={onPress} customStyle={{ backgroundColor: Theme.WHITE }}>
      <View style={styles.container}>
        <View style={styles.iconTitleContainer}>
          <View style={styles.iconContainer}>
            {icon}
          </View>
          <Text style={styles.title}>{title}</Text>
        </View>
        <ArrowIcon color={Theme.GREY_DARK_MEDIUM} width={defaultScale(12)} height={defaultScale(12)} />
      </View>
    </Tile>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingLeft: defaultScale(10),
    paddingRight: defaultScale(16),
    paddingVertical: defaultScale(10),
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  iconContainer: {
    width: defaultScale(24),
  },
  icon: {
    alignSelf: 'center',
  },
  iconTitleContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  title: {
    ...Theme.textStyle.bodyCopyReg,
    paddingLeft: defaultScale(14),
    color: Theme.CHARCOAL,
    alignItems: 'center',
  },
});
